import ApplicationAdapter from 'register-partners-js/adapters/application';

export default class PaymentIntentAdapter extends ApplicationAdapter {
  pathForType() {
    return 'payment_intents';
  }
}
